import { render, staticRenderFns } from "./TableInputs.vue?vue&type=template&id=0ccddada&"
import script from "./TableInputs.vue?vue&type=script&lang=js&"
export * from "./TableInputs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports